import type { ProjectResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import type { LoaderData } from "./SharedLiveStatusPage";
import { SharedLiveStatusPage, sharedLiveStatusPageLoader } from "./SharedLiveStatusPage";
export const untenantedApplicationLiveStatusPageLoader = sharedLiveStatusPageLoader;
interface UntenantedApplicationLiveStatusPageProps {
    loaderData: LoaderData;
    project: ProjectResource;
}
export function UntenantedApplicationLiveStatusPage({ loaderData, project }: UntenantedApplicationLiveStatusPageProps) {
    return <SharedLiveStatusPage loaderData={loaderData} project={project}/>;
}
